import { __awaiter } from '../../_virtual/_tslib.js';

const processTask = (tasks, type = 'before', params) => {
    const result = [];
    let isRunning = false;
    let i = 0;
    return {
        start() {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                if (isRunning)
                    return;
                isRunning = true;
                while (i < tasks.length) {
                    const plugin = tasks[i];
                    if (type === 'before') {
                        // 执行before 钩子
                        result.push(yield (plugin === null || plugin === void 0 ? void 0 : plugin.mirrorHandleBefore(params.type, params.data)));
                    }
                    else {
                        // 执行after钩子
                        result.push(yield (plugin === null || plugin === void 0 ? void 0 : plugin.mirrorHandleAfter(params.type, params.data)));
                    }
                    i++;
                    if (!isRunning)
                        return;
                }
                isRunning = false;
                resolve(result);
            }));
        }
    };
};
// 定时器类
class Timer {
    constructor() {
        this.timeID = null;
        this.func = null;
    }
    repeat(func, ms) {
        this.func = func;
        this.timeID = setTimeout(() => {
            func();
            this.repeat(func, ms);
        }, ms);
    }
    clear() {
        clearTimeout(this.timeID);
    }
}

export { Timer, processTask };
